export enum ThemeStyle {
  MODERN = 'modern',
  STANDARD = 'standard',
}

export enum ThemeStyleRadius {
  MODERN = 30,
  STANDARD = 4,
}

export enum ThemeMode {
  LIGHT = 'light',
  SEMI_DARK = 'semi-dark',
  DARK = 'dark',
}

export enum LayoutType {
  FULL_WIDTH = 'full-width',
  BOXED = 'boxed',
}

export enum NavStyle {
  DEFAULT = 'default',
  MINI = 'mini',
  STANDARD = 'standard',
  HEADER_USER = 'user-header',
  HEADER_USER_MINI = 'user-mini-header',
  DRAWER = 'drawer',
  BIT_BUCKET = 'bit-bucket',
  H_DEFAULT = 'h-default',
  HOR_LIGHT_NAV = 'hor-light-nav',
  HOR_DARK_LAYOUT = 'hor-dark-layout',
}

export enum FooterType {
  FIXED = 'fixed',
  FLUID = 'fluid',
}

export enum HeaderType {
  DARK = 'dark',
  LIGHT = 'light',
}

export enum RouteTransition {
  NONE = 'none',
  FADE = 'fade',
  SLIDE_LEFT = 'slideLeft',
  SLIDE_RIGHT = 'slideRight',
  SLIDE_UP = 'slideUp',
  SLIDE_DOWN = 'slideDown',
}

export enum Fonts {
  LIGHT = 'Gilroy-Light',
  REGULAR = 'Gilroy-Regular',
  MEDIUM = 'Gilroy-Medium',
  BOLD = 'Gilroy-Bold',
  EXTRA_BOLD = 'Gilroy-ExtraBold',
}

export enum InfoDialogChoice {
  TABS = 'TABS',
  SOILS_AND_CROPS = 'SOILS_AND_CROPS',
  FILTERS = 'FILTERS',
  SUBSCRIPTIONS = 'SUBSCRIPTIONS',
  NONE = 'NONE',
}

export enum IrrigationDataPicked {
  IRRIGATION = 'irrigation',
  PLUIE = 'pluie',
}
